"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Fire24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", d: "M7.025 7.014c-.31-.185-.733-.184-.933.117a11.132 11.132 0 0 0-.593 1.005v.001C4.759 9.554 4.082 11.537 4 14a8 8 0 1 0 16 0c-.154-3.172-1.293-4.708-2.645-5.99-1.005-.954-2.863-2.767-2.863-4.01 0-.236.006-.451.018-.648.095-1.572.541-1.962.853-2.235.046-.04.09-.078.129-.117-.07.005-.14.013-.212.022-.763.103-1.698.457-2.634 1.12-1.278.903-2.558 2.38-3.406 4.578a14.28 14.28 0 0 0-.748 2.78 8.035 8.035 0 0 1-.756-1.229 8.754 8.754 0 0 1-.378-.874.765.765 0 0 0-.333-.383Zm-.342 3.397A12.02 12.02 0 0 0 6 14.032a6 6 0 0 0 12 .015c-.07-1.327-.337-2.209-.66-2.852-.33-.656-.775-1.178-1.362-1.734-.504-.479-1.305-1.249-1.985-2.088a8.913 8.913 0 0 1-.964-1.423 4.898 4.898 0 0 1-.425-1.078c-.911 1.057-1.75 2.644-2.14 4.96a2 2 0 0 1-3.572.868 9.62 9.62 0 0 1-.209-.289Z", clipRule: "evenodd" }));
}
function Fire24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Fire24Svg, Object.assign({}, svgProps)));
}
exports.default = Fire24;
//# sourceMappingURL=Fire24.js.map